const HOSTS_WITH_STUDIO_URL_IN_PATH = [
  'beta-studio.heymarvelous.com',
  'localhost',
  '127.0.0.1',
];

export default HOSTS_WITH_STUDIO_URL_IN_PATH;